module.exports = __webpack_public_path__ + "media/images/icon-home-019a4b8c0686210208ad54e622322143.svg";